import { CorporateExperimentByBusiness, UntypedExperiment } from "../types";

const CORP_FREE_FDA_ID = "corp-free-fda";

interface ParsedGateData {
  variantName: string;
  data: { tags: string[] };
}

const parseGateExperiment = (
  gate: UntypedExperiment
): ParsedGateData | null => {
  try {
    const parsed = JSON.parse(gate.variant) as ParsedGateData;
    if (parsed.variantName && parsed.data?.tags) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
};

export const resolvePreselectAccountId = (
  utmTag: string,
  gateExperiment: UntypedExperiment | undefined,
  businessExperiments: CorporateExperimentByBusiness[]
): string | null => {
  if (!gateExperiment) return null;

  const parsed = parseGateExperiment(gateExperiment);
  const parsedVariant = parsed?.variantName.toLowerCase();
  if (
    !parsed ||
    parsedVariant === "control" ||
    !parsed.data.tags.includes(utmTag)
  ) {
    return null;
  }

  const corpFreefdaExperiments = businessExperiments.filter(
    (exp) => exp.id === CORP_FREE_FDA_ID
  );

  // For single account users doesn't matter what the experiment state is.
  // No need to run preselection
  if (corpFreefdaExperiments.length <= 1) {
    return null;
  }

  const eligibleAccountRefIds = corpFreefdaExperiments
    .filter(
      (exp) =>
        exp.variant.toLowerCase() !== "control" && exp.eligibleAccountRefId
    )
    .map((exp) => exp.eligibleAccountRefId!);

  const uniqueIds = [...new Set(eligibleAccountRefIds)];

  if (uniqueIds.length === 1) {
    return uniqueIds[0];
  }

  return null;
};
